import moment from "moment";
import { CreditReportConsumerInformation } from "types/landlord/reports";
import { Row } from "views/applications-id-report/components/Row";
import { Section } from "views/applications-id-report/components/Section";

interface ConsumerInformationProps {
  consumer_information?: CreditReportConsumerInformation;
  isNoHit: boolean;
}

const leftColumnFields = [
  { title: "Other names", valueKey: "other_names" },
  { title: "Current address", valueKey: ["address1", "city", "state", "zip"] },
  {
    title: "Date reported address",
    valueKey: "date_reported_address",
    type: "date"
  },
  {
    title: "Address variance indicator",
    valueKey: "address_variance_indicator"
  },
  { title: "Current phone number", valueKey: "current_phone_number" },
  { title: "Date reported phone", valueKey: "date_reported_phone_number" }
];

const rightColumnFields = [
  { title: "SSN status", valueKey: "ssn_status" },
  { title: "SSN match flags", valueKey: "ssn_match_flags" },
  { title: "Issue date", valueKey: "issue_date", type: "date" },
  { title: "Issue state", valueKey: "issue_state" },
  { title: "Death date", valueKey: "death_date", type: "date" },
  {
    title: "Date file was established",
    valueKey: "date_file_established",
    type: "date"
  },
  {
    title: "Date of most recent activity",
    valueKey: "date_most_recent_activity",
    type: "date"
  }
];

export const ConsumerInformation = ({
  consumer_information,
  isNoHit
}: ConsumerInformationProps) => {
  if (isNoHit)
    return (
      <Section sectionTitle="Consumer information" maxWidth="none">
        <p className="text-base font-medium text-content-300">
          No data available
        </p>
      </Section>
    );

  return (
    <Section sectionTitle="Consumer information" maxWidth="none">
      <div className="flex w-full flex-row flex-wrap gap-4">
        {/* Left column */}
        <div className="w-[360px]">
          <div>
            {leftColumnFields.map((l) => {
              if (Array.isArray(l.valueKey)) {
                const value = l.valueKey
                  .map((key) => consumer_information?.[key])
                  .join(", ");
                return (
                  <Row
                    className="my-3"
                    key={l.title}
                    title={l.title}
                    value={value || "-"}
                  />
                );
              }

              let value =
                l.type === "date" &&
                consumer_information?.[l.valueKey] &&
                moment(consumer_information[l.valueKey]).isValid()
                  ? moment(consumer_information[l.valueKey]).format(
                      "MMM DD, YYYY"
                    )
                  : consumer_information?.[l.valueKey];

              if (Array.isArray(value)) value = value.join(", ");

              return (
                <Row
                  className="my-3"
                  key={l.title}
                  title={l.title}
                  value={value || "-"}
                />
              );
            })}
          </div>
        </div>

        {/* Right column */}
        <div className="w-[360px]">
          {rightColumnFields.map((r) => {
            let value =
              r.type === "date" &&
              consumer_information?.[r.valueKey] &&
              moment(consumer_information[r.valueKey]).isValid()
                ? moment(consumer_information[r.valueKey]).format(
                    "MMM DD, YYYY"
                  )
                : consumer_information?.[r.valueKey];

            if (Array.isArray(value)) value = value.join(", ");

            return (
              <Row
                className="my-3"
                key={r.title}
                title={r.title}
                value={value || "-"}
              />
            );
          })}
        </div>
      </div>
    </Section>
  );
};
